import { getCalendarSurfaceStore } from 'owa-calendar-surface-surface-store';
import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';

export function getNumSurfaceViews() {
    const { isInSplitView } = getCalendarSurfaceStore();

    // VSO 84478: need to investigate why getSelectedCalendars() returns 0 on boot, patching here as we need a value other than 0 on boot
    return isInSplitView ? Math.max(getSelectedCalendars().length, 1) : 1;
}
